<template>
  <v-layout class="header neutral-layout">
    <v-row>
      <v-col sm="6" cols="12">
        <a href="/" :title="$t('common.goHome')">
          <img
            v-if="language === 'pt'"
            class="header-img"
            src="~@/assets/img/logo-bd-pt.png"
            alt="Bibliociencia"
          />
          <img
            v-if="language !== 'pt'"
            class="header-img"
            src="~@/assets/img/logo-bd-es.png"
            alt="Bibliociencia"
          />
        </a>
      </v-col>
      <v-col
        sm="6"
        cols="12"
        class="d-flex"
        :class="
          $vuetify.breakpoint.xs ? 'justify-space-between' : 'justify-end'
        "
      >
        <!-- Language Selector -->
        <div class="language-container">
          <v-select
            :items="items"
            v-model="language"
            item-text="language"
            item-value="code"
            elevate="4"
            solo
            class="lang-selector"
            dark
            @change="handleLanguageChange($event)"
          ></v-select>
        </div>
        <!-- Home Button -->
        <div class="action-button-container" v-if="isLoggedIn && !isHome">
          <v-btn
            @click="goHome"
            elevate="4"
            large
            dark
            :title="$t('common.goHome')"
            class="action-button home-button"
          >
            <v-icon>mdi-home</v-icon>
          </v-btn>
        </div>
        <!-- Logout Button -->
        <div class="action-button-container" v-if="isLoggedIn">
          <v-btn @click="logout" elevate="4" large dark class="action-button">
            {{ $t('common.logout') }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import { auth } from '../firebase'

export default {
  data: () => {
    return {
      language: localStorage.getItem('bd-biblio-lang') || 'es',
      isLoggedIn: false,
      isHome: false
    }
  },
  methods: {
    handleLanguageChange(value) {
      localStorage.setItem('bd-biblio-lang', value)
      location.reload()
    },
    logout: function() {
      auth.signOut().then(() => {
        this.$router.push({ name: 'login' })
      })
    },
    goHome: function() {
      this.$router.push({ name: 'home' })
    }
  },
  computed: {
    items() {
      return [
        {
          language: this.$t('common.es'),
          code: 'es'
        },
        {
          language: this.$t('common.pt'),
          code: 'pt'
        }
      ]
    }
  },
  created() {
    if (auth.currentUser) {
      this.isLoggedIn = true
    }
    if (this.$route.meta.isHome) {
      this.isHome = true
    }
  }
}
</script>

<style lang="scss">
.header {
  @media only screen and (min-width: 600px) {
    margin-top: 30px;
  }
  @media only screen and (max-width: 599px) {
    padding-top: 10px;
    .col-12 {
      padding: 0;
    }
  }
  .header-img {
    width: 100%;
    max-width: 375px;

    @media only screen and (min-width: 600px) {
      max-width: 500px;
    }
  }
  .language-container {
    width: 135px;

    .theme--dark.v-text-field--solo > .v-input__control > .v-input__slot {
      margin-bottom: 0;
      background: rgb(0 69 140 / 84%);
    }

    .v-text-field__details {
      display: none;
    }
  }
  .action-button-container {
    margin-left: 20px;

    .action-button.v-btn:not(.v-btn--round).v-size--large {
      background-color: rgba(0, 69, 140, 0.84);
      height: 48px;

      &.home-button {
        min-width: 60px;
      }
    }
  }
}
</style>
